import { CloseCircleOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { useUploadFormStore } from 'stores/local/forms/UploadFormStore';

import s from './ErrorFileState.module.scss';

const ErrorFileState: React.FC = () => {
  const { t } = useTranslation();
  const { errorMessage } = useUploadFormStore();

  const errorText = errorMessage || t('formFilling.dndError');
  const errorHint = errorMessage ? null : t('formFilling.dndErrorHint');

  return (
    <>
      <p>
        <CloseCircleOutlined className={s.icon} />
      </p>
      <Typography.Text type="danger" className="ant-upload-text">
        {errorText}
      </Typography.Text>
      {errorHint && <p className="ant-upload-hint">{errorHint}</p>}
    </>
  );
};

export default observer(ErrorFileState);
